export default __webpack_public_path__ + "static/media/burger.219be442.svg";